"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Test whether a string is camel-case.
 */
var hasSpace = /\s/;
var hasSeparator = /(_|-|\.|:)/;
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 */
function noCaseIt(str) {
    if (hasSpace.test(str)) {
        return str.toLowerCase();
    }
    if (hasSeparator.test(str)) {
        return (unseparate(str) || str).toLowerCase();
    }
    if (hasCamel.test(str)) {
        return uncamelize(str).toLowerCase();
    }
    return str.toLowerCase();
}
exports.noCaseIt = noCaseIt;
/**
 * Separator splitter.
 */
var separatorSplitter = /[\W_]+(.|$)/g;
/**
 * Un-separate a `string`.
 */
function unseparate(str) {
    return str.replace(separatorSplitter, function (m, next) { return (next ? " " + next : ""); });
}
/**
 * Camelcase splitter.
 */
var camelSplitter = /(.)([A-Z]+)/g;
/**
 * Un-camelcase a `string`.
 */
function uncamelize(str) {
    return str.replace(camelSplitter, function (m, previous, uppers) {
        return previous +
            " " +
            uppers
                .toLowerCase()
                .split("")
                .join(" ");
    });
}
